<template>
  <div :class="{'range-disabled': disabled}">
    <div class="range-labels-block">
      <vcirclelabel
        :value="dateInner"
        :disabled="disabled"
        :label="$tr('vacancy.preferences.application.dateInner')"
        @input="setSelectedRange(true)"
      />
      <vcirclelabel
        :value="!dateInner"
        :disabled="disabled"
        :label="$tr('vacancy.preferences.application.dateOuter')"
        @input="setSelectedRange(false)"
      />
    </div>
    <div class="dates-row">
      <span class="dates-row-info-first" v-if="!is_japan_locale">{{$tr('common.from')}}&nbsp;</span>
      <date-component
        :data="dateStart"
        :current_locale="currentLocale"
        :hideByClick="true"
        :disabled="disabled"
        :disableCurrentDates="true"
        :maxDate="dateEnd ? dateEnd : ''"
        :isHidePickerByStart="true"
        @set_valid_date="set_valid_date_min"
        @update="updateDateStart"
        @input="updateDateStart"
        @set_valid_moment_date="setValidDateStart"/>
      <span class="dates-row-info-first" v-if="is_japan_locale">&nbsp;{{$tr('common.from')}}&nbsp;</span>
      <span class="dates-row-info-second" v-if="!is_japan_locale">{{$tr('common.to')}}&nbsp;</span>
      <date-component
        :data="dateEnd"
        :current_locale="currentLocale"
        :hideByClick="true"
        :disabled="disabled"
        :disableCurrentDates="true"
        :minDate="dateStart ? dateStart : ''"
        :isHidePickerByStart="true"
        @set_valid_date="set_valid_date_max"
        @update="updateDateEnd"
        @input="updateDateEnd"
        @set_valid_moment_date="setValidDateEnd"/>
      <span class="dates-row-info-second" v-if="is_japan_locale">&nbsp;{{$tr('common.to')}}&nbsp;</span>
    </div>

    <div class="range-arrow">
      <div class="range-item range-item--first" :class="{'range-item-hidden': !showFirstRangeItem, 'range-green': dateInner, 'range-grey': !dateInner}">
        <span v-if="!dateInner">{{$tr('vacancy.preferences.application.dateDropout')}}</span>
        <span v-else>👍🏻 {{$tr('interview.landing.modules.iframe.button')}}</span>
        <div class="range-item-info" v-if="dateStart && validDateStart">
          {{dateStart}}
        </div>
      </div>
      <div class="range-item range-item--second" :class="{'range-item-big': isOneRangeEmpty, 'range-green': !dateInner, 'range-grey': dateInner}">
        <span v-if="dateInner">{{$tr('vacancy.preferences.application.dateDropout')}}</span>
        <span v-else>👍🏻 {{$tr('interview.landing.modules.iframe.button')}}</span>
        <div class="range-item-info" v-if="dateEnd && validDateEnd">
          {{dateEnd}}
        </div>
      </div>
      <div class="range-item range-item--third" :class="{'range-item-hidden': !showLastRangeItem, 'range-green': dateInner, 'range-grey': !dateInner}">
        <span v-if="!dateInner">{{$tr('vacancy.preferences.application.dateDropout')}}</span>
        <span v-else>👍🏻 {{$tr('interview.landing.modules.iframe.button')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import date from '@/routes_new/inner/vacancy/application/components/date.vue';

export default {
  name: 'vdate_range_slider',

  components: {
    DateComponent: date
  },

  props: {
    dateStart: {
      type: String,
      default: ''
    },
    dateEnd: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dateInner: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      validDateStart: true,
      validDateEnd: true
    }
  },

  computed: {
    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },
    currentLocale() {
      return this.$store.getters['locale/current'];
    },
    showFirstRangeItem() {
      return (this.dateStart && this.dateEnd && this.validDateStart && this.validDateEnd)
      || (!this.dateStart && !this.dateEnd)
      || (!this.validDateStart && !this.validDateEnd)
      || (this.dateStart && this.validDateStart);
    },
    showLastRangeItem() {
      return (this.dateStart && this.dateEnd && this.validDateStart && this.validDateEnd)
      || (!this.dateStart && !this.dateEnd)
      || (!this.validDateStart && !this.validDateEnd)
      || (this.dateEnd && this.validDateEnd);
    },
    isOneRangeEmpty() {
      return (this.dateStart && this.validDateStart && (!this.dateEnd || !this.validDateEnd))
      ||  (this.dateEnd && this.validDateEnd && (!this.dateStart || !this.validDateEnd));
    }
  },

  methods: {
    set_valid_date_min(v) {
      if (this.dateStart && this.dateEnd && moment(this.dateEnd, 'DD-MM-YYYY').diff(moment(this.ateStart, 'DD-MM-YYYY'), 'day') < 0) {
        this.$emit('set_valid_date_min', false);
        return;
      }
      this.$emit('set_valid_date_min', v);
    },
    set_valid_date_max(v) {
      if (this.dateStart && this.dateEnd && moment(this.dateEnd, 'DD-MM-YYYY').diff(moment(this.ateStart, 'DD-MM-YYYY'), 'day') < 0) {
        this.$emit('set_valid_date_max', false);
        return;
      }
      this.$emit('set_valid_date_max', v);
    },
    setSelectedRange(val) {
      this.$emit('setSelectedRange', val)
    },
    changeDateStart(val) {
      this.$emit('changeDateStart', val)
    },
    changeDateEnd(val) {
      this.$emit('changeDateEnd', val)
    },
    setValidDateStart(v) {
      this.validDateStart = v;
    },
    setValidDateEnd(v) {
      this.validDateEnd = v;
    },
    updateDateStart(v) {
      this.$emit('changeDateStart', v.date);
    },
    updateDateEnd(v) {
      this.$emit('changeDateEnd', v.date);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

  .dates-row {
    display: flex;
    align-items: center;
    margin: 14px 0 20px;

    ::v-deep .answers_date {
      width: auto;
      padding-top: 0;
      margin-left: 22px;

      .date {
        width: 144px;
        font-size: 14px;
      }
    }
  }

  .range-arrow {
    display: flex;
    align-items: center;
    // padding-right: 30px;
    padding-bottom: 5px;
    background: url('/static/images/elements/date-range.svg') -40px 37px no-repeat;
    background-size: 730px auto;
  }

  .range-item {
    position: relative;
    flex: 1;
    height: 40px;
    transition: all ease-in-out .2s;
    display: flex;
    align-items: center;
    justify-content: center;
    // // font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    text-align: center;
    background: #9FAAB6;
    color: #233346;

    &.range-green {
      background: rgba(75,177,60, .25);
      color: $green-hover;
    }

    &.range-grey {
      background: rgba(159,170,182, .25);
      color: #233346;
    }
  }

  .range-item-info {
    position: absolute;
    bottom: -24px;
    left: calc(100% - 38px);
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    align-items: center;
    text-align: center;
    color: #9FAAB6;
    white-space: nowrap;
  }

  .range-item--first {
    background: red;
  }
  .range-item--second {
    background: green;
  }
  .range-item--third {
    background: blue;
  }

  .range-item-hidden {
    width: 0;
    flex: 0;
    opacity: 0;
    transition: all ease-in-out .2s;
  }
  .range-item-big {
    flex: 2;
  }
  .range-disabled {
    opacity: .5;
    cursor: not-allowed;
  }
  .range-labels-block {
    margin-left: -10px;
    margin-top: 10px;

    ::v-deep .vcircle_label {
      padding-bottom: 0px;
      padding-top: 6px;

      .circle_label {
        margin-left: 10px;
      }
    }
  }

  .dates-row-info-first {
    display: block;
    margin-right: -14px;
  }
  .dates-row-info-second {
    display: block;
    margin-left: 6px;
    margin-right: -18px;
  }
</style>
